import React from 'react';
import PropTypes from 'prop-types';

import { purgeItemType } from 'types';
import PurgeGroup from './components/PurgeGroup';

const PurgeList = ({ purgeList }) => (
  <React.Fragment>
    {Object.entries(purgeList).map(([key, val]) => (
      <PurgeGroup key={key} name={key} category={val} />
    ))}
  </React.Fragment>
);

PurgeList.propTypes = {
  purgeList: PropTypes.shape(purgeItemType),
};

export default PurgeList;
